import t from "@/lang/lang";
import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import { CardSkeleton } from "@/shared/components/card-skeleton";
import { RTKQueryErrorAlert } from "@/shared/components/errors/rtk-query-error-alert";
import { SvgDataUriInput } from "@/shared/components/images/svg-data-uri-input";
import { inputValidationErrorMessages } from "@/shared/components/errors/input-error-messages";
import { useOptimisticDebouncedMutation } from "@/shared/lib/debounce/use-optimistic-debounced-mutation";
import {
  updateMasterDataPdfCache,
  usePatchMasterDataPdfMutation,
  useShowMasterDataPdfQuery,
} from "@/services/backend/company/api/master-data-pdf";
import {
  MasterDataPdfDefault,
  MasterDataPdfFooterData,
} from "@/services/backend/company/types/master-data-pdf";

export function MasterDataPdfFooterDataCard({ id }: { id: string }) {
  const { data, error, isLoading } = useShowMasterDataPdfQuery({ id });

  return (
    <div>
      {data && <Content data={data} />}
      {error && <RTKQueryErrorAlert error={error} />}
      {isLoading && <CardSkeleton />}
    </div>
  );
}

const slots = ["logo1", "logo2", "logo3", "logo4"] as const;

function Content({ data }: { data: MasterDataPdfDefault }) {
  const [set, { error }] = useOptimisticDebouncedMutation(
    { id: data.id },
    updateMasterDataPdfCache,
    usePatchMasterDataPdfMutation(),
    { delay: 0 },
  );

  const setFooterData = (footerData: MasterDataPdfFooterData) =>
    set({ id: data.id, footerData }, { ...data, footerData });

  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Fußzeile")}</CardTitle>
        <CardDescription>
          {t(
            "Die Logoleiste am Fuß des Dokuments, von links nach rechts. Nur SVG.",
          )}
        </CardDescription>
      </CardHeader>
      <CardContent className="grid gap-6 sm:grid-cols-2">
        {slots.map((slot, index) => (
          <SvgDataUriInput
            key={slot}
            label={`${t("Logo")} ${index + 1}`}
            value={data.footerData[slot]}
            onValueChange={(value) =>
              setFooterData({ ...data.footerData, [slot]: value })
            }
            errors={inputValidationErrorMessages(error, `footerData.${slot}`)}
          />
        ))}
      </CardContent>
    </Card>
  );
}
